import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Support from "../views/Support.vue";
import Admin from "../views/Admin/Admin";
import { List, Timer } from "../views/Admin/components";
import Users from "../views/Admin/Users";
import Dictionary from "../views/Admin/Dictionary";
import Uploader from "../views/Admin/Uploader.vue";
import Feedbacks from "../views/Admin/Feedbacks";

Vue.use(VueRouter);

const routes = [
	{
		path: "*",
		redirect: "/",
	},
	{
		path: "/",
		name: "Home",
		component: Home,
	},
	{
		path: "/support",
		name: "support",
		component: Support,
	},
	{
		path: "/android",
		name: "android",
	},
	{
		path: "/ios",
		name: "ios",
	},
	{
		path: "/demo",
		name: "demo",
	},
	{
		path: "/feedback",
		name: "feedback",
	},
	{
		path: "/admin",
		component: Admin,
		children: [
			{
				component: List,
				name: "list",
				path: "",
			},
			{
				component: Timer,
				name: "timer",
				path: "/timer/:song_id?",
			},
			{
				component: Users,
				name: "users",
				path: "/users",
			},
			{
				component: Feedbacks,
				name: "feedbacks",
				path: "/feedbacks",
			},
			{
				component: Dictionary,
				name: "dictionary",
				path: "/dictionary",
			},
			{
				component: Uploader,
				name: "uploader",
				path: "/uploader",
			},
		],
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

router.beforeEach((to, from, next) => {
	if (to.name === "ios")
		window.location = "https://apps.apple.com/in/app/alduin/id1508127070";
	else if (to.name === "android")
		window.location =
			"https://play.google.com/store/apps/details?id=com.alduin&hl=en&gl=US";
	else if (to.name === "demo")
		window.location =
			"https://firebasestorage.googleapis.com/v0/b/alduin-app.appspot.com/o/demo%20v2.7.mp4?alt=media&token=8bfe1400-0124-44fd-bc00-eab160662cb7";
	else if (to.name === "feedback") {
		window.location = "https://5u4kpz4r8s9.typeform.com/to/rnOmuxic";
	} else next();
});

export default router;
